(() => {
	const tocSection = document.querySelector('[data-article-toc]');
	if (!tocSection) return;

	const main = document.querySelector('main#MainContent');
	if (!main) return;

	if (!document.querySelector('main article.article-template, main .article-template')) return;

	const navEl = tocSection.querySelector('[data-article-toc-nav]');
	const contentEl = tocSection.querySelector('[data-article-toc-content]');
	if (!navEl || !contentEl) return;

	// Prevent double-run (theme editor / section reloads)
	if (tocSection.dataset.tocInitialized === 'true') return;
	tocSection.dataset.tocInitialized = 'true';

	// Put TOC section at top of <main>
	main.insertBefore(tocSection, main.firstChild);

	// Move the article header to be directly before the TOC section (outside wrapper)
	const articleHeader = document.querySelector('header.article-header');
	if (!articleHeader) return; // per your requirement: must exist

	main.insertBefore(articleHeader, tocSection);

	// Move everything else from <main> into TOC content (except header + toc)
	const nodesToMove = Array.from(main.childNodes).filter((node) => {
		if (node === tocSection) return false;
		if (node === articleHeader) return false;
		return true;
	});

	nodesToMove.forEach((node) => contentEl.appendChild(node));

	// Build TOC from headings inside contentEl
	const selector = 'h2';
	const headings = Array.from(contentEl.querySelectorAll(selector)).filter((h) => {
		if (!h.textContent || !h.textContent.trim().length) return false;

		// Exclude headings inside unwanted sections
		if (h.closest('.featured-product')) return false;
		if (h.closest('.newsletter')) return false;
		if (h.closest('.blog')) return false;

		return true;
	});
	
	if (!headings.length) {
		navEl.style.display = 'none';
		return;
	}

	const slugify = (str) =>
		str
			.toLowerCase()
			.trim()
			.replace(/['"]/g, '')
			.replace(/[^a-z0-9]+/g, '-')
			.replace(/^-+|-+$/g, '');

	const used = new Set();
	headings.forEach((h) => {
		if (!h.id) {
			let base = slugify(h.textContent);
			if (!base) base = 'section';
			let id = base;
			let i = 2;
			while (used.has(id) || document.getElementById(id)) id = `${base}-${i++}`;
			h.id = id;
		}
		used.add(h.id);
	});

	const ul = document.createElement('ul');
	ul.className = 'wus-article-toc__list';

	headings.forEach((h) => {
		const li = document.createElement('li');
		const a = document.createElement('a');

		a.href = `#${h.id}`;
		a.textContent = h.textContent.trim();
		a.dataset.tocTarget = h.id;

		li.appendChild(a);
		ul.appendChild(li);
	});

	const toggleBtn = document.createElement('button');
	toggleBtn.type = 'button';
	toggleBtn.className = 'wus-article-toc__title wus-article-toc__toggle';
	toggleBtn.innerHTML = 'Inhalt';
	toggleBtn.setAttribute('aria-expanded', 'false');
	toggleBtn.setAttribute('aria-controls', 'wus-article-toc-list');

	// ensure list has an id for aria-controls
	ul.id = 'wus-article-toc-list';

	navEl.innerHTML = '';
	navEl.appendChild(toggleBtn);
	navEl.appendChild(ul);

	// collapsible behavior
	const mq = window.matchMedia('(min-width: 990px)');

	const setOpen = (open) => {
		navEl.classList.toggle('is-open', open);
		toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');

		if (open) {
			ul.style.maxHeight = ul.scrollHeight + 'px';
		} else {
			ul.style.maxHeight = '0px';
		}
	};

	const syncMode = () => {
		if (mq.matches) {
			// desktop: always open, no toggle
			toggleBtn.disabled = true;
			toggleBtn.removeAttribute('aria-expanded');
			navEl.classList.add('is-open');
			ul.style.maxHeight = '';
		} else {
			// mobile/tablet: collapsible, default closed
			toggleBtn.disabled = false;
			toggleBtn.setAttribute('aria-expanded', navEl.classList.contains('is-open') ? 'true' : 'false');

			// default: closed
			navEl.classList.remove('is-open');
			setOpen(false);
		}
	};

	toggleBtn.addEventListener('click', () => {
		if (mq.matches) return;
		const open = !navEl.classList.contains('is-open');
		setOpen(open);
	});

	// Recalc on resize / breakpoint change
	mq.addEventListener('change', syncMode);
	window.addEventListener('resize', () => {
		if (!mq.matches && navEl.classList.contains('is-open')) {
			// keep height correct if fonts wrap etc.
			ul.style.maxHeight = ul.scrollHeight + 'px';
		}
	});

	syncMode();

	// Smooth scroll with header offset
	navEl.addEventListener('click', (e) => {
		const a = e.target.closest('a[href^="#"]');
		if (!a) return;

		const id = a.getAttribute('href').slice(1);
		const target = document.getElementById(id);
		if (!target) return;

		e.preventDefault();

		const header = document.querySelector('.header-wrapper');
		const headerH = header ? header.getBoundingClientRect().height : 0;
		const y = window.scrollY + target.getBoundingClientRect().top - headerH - 16;

		history.pushState(null, '', `#${id}`);
		window.scrollTo({ top: y, behavior: 'smooth' });
	});

	// Active state
	const links = Array.from(navEl.querySelectorAll('a[data-toc-target]'));
	const setActive = (id) => links.forEach((l) => l.classList.toggle('is-active', l.dataset.tocTarget === id));

	const io = new IntersectionObserver(
		(entries) => {
			const visible = entries
				.filter((en) => en.isIntersecting)
				.sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

			if (visible[0]?.target?.id) setActive(visible[0].target.id);
		},
		{ rootMargin: '-20% 0px -70% 0px', threshold: 0.01 }
	);

	headings.forEach((h) => io.observe(h));

	setActive(location.hash?.slice(1) || headings[0].id);
})();